// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"ImagesPage_subTitle__1mN6v","img":"ImagesPage_img__1mjaC","center":"ImagesPage_center__cfsgT"};